import type { ConceptDef } from '../types';

export const dressingSequence: ConceptDef = {
  kind: 'sequenceTap',
  id: 'dressing-sequence',
  label: 'Dressing Sequence',
  category: 'Daily living',
  description: 'Tap dressing steps in order.',
  config: {
    promptMode: 'AUDIO',
    sequences: [
      { label: 'Get dressed.', items: ['👕 shirt', '👖 pants', '🧦 socks', '👟 shoes'] },
      { label: 'Bundle up.', items: ['🧣 scarf', '🧥 coat', '🧤 gloves', '🎩 hat'] },
    ],
  },
};
